import React, {Component} from 'react';
import 'assets/sass/dashboard/deposits/Deposits.scss';
import {QRCode} from "react-qr-svg";
import {app} from "app/app";
import {ReactSVG} from "react-svg";
import {images} from "assets/img/common/common";
import {CopyToClipboardElement} from "components/dashboard/common/CopyToClipboardElement";
import {CoinDepositBlockchainWarning} from "buenLib/components/CoinDepositBlockchainWarning"
import { AppContext } from 'app/state/AppContext';
import {Currency} from "../../../../../buenLib/domain/Currency";

export class Receive extends Component {
    static contextType = AppContext;

    render() {
        if (app.currentUser().canWithdrawCoin()) {
            if (this.walletAddress()) {
                return (
                    <>
                        <div className="text-center my-4">
                            <p>Escaneá el código para realizar el depósito</p>
                            <QRCode className="wallet-address-qr-code"
                                    value={this.walletAddress()}/>
                            <p>O copiá la siguiente dirección</p>
                            <span className="wallet-deposit-address">{this.walletAddress()}</span>
                            <CopyToClipboardElement
                                content={<ReactSVG className="icon-copy big" src={images.copy}/>}
                                valueToCopy={this.walletAddress()}
                                mouseOverTooltipMessage="Clickeá para copiar la dirección"
                                copiedTooltipMessage="¡Dirección copiada al portapapeles!"
                            />
                        </div>
                        <CoinDepositBlockchainWarning currency={this.props.currency} />
                    </>
                )
            } else {
                return <>
                    <div className="text-center">
                        Estamos generando la dirección para depositar. Por favor reintentá en unos segundos.
                    </div>
                </>;
            }
        } else {
            //return <p>[ ! ] Debés terminar tu verificación para poder recibir {this.presentedCoinCurrency()}</p>;
            let verificationStateCode = app.currentUser().verificationState().code();
            let errorMessage = app.errorMessageMapper()[verificationStateCode]
            return <p> [ ! ] {errorMessage} </p>;
        }
    }

    walletAddress() {
        const currency = this.props.currency;
        if (currency === Currency.BTC) {
            return this.props.depositAddresses?.addresses?.[currency]?.bitcoin;
        }
        return this.props.depositAddresses?.addresses?.[currency]?.bsc;
    }

    status() {
        return  this.props.depositAddresses?.status;
    }

    presentedCoinCurrency() {
        const { getCurrencyInstance } = this.context;
        return getCurrencyInstance(this.props.currency).code();
    }
}
